<mat-progress-bar
  class="progress-bar"
  mode="indeterminate"
  *ngIf="loading"
></mat-progress-bar>
<!-- US 6931: Read-only view; role assignments are managed in Role Catalog -->
<div class="read-only-note px-1 pt-2">
  <mat-icon class="blue">info</mat-icon>
  <span
    >This list is read-only. To add or remove roles for these privileges, use
    Administration &gt; Catalogs &gt; Role Catalog.</span
  >
</div>
<div class="privileges p-1 pt-2">
  <div class="row" *ngFor="let radMonitorPrivilege of radMonitorPrivileges">
    <div class="col-5">{{ radMonitorPrivilege.name }}</div>
    <div class="col-7">
      <mat-chip-set aria-label="Roles">
        <mat-chip
          *ngFor="let rolePrivilege of radMonitorPrivilege.rolePrivileges"
          [disableRipple]="true"
        >
          {{ rolePrivilege?.role?.code }}
        </mat-chip>
        <span
          class="no-roles"
          *ngIf="!radMonitorPrivilege.rolePrivileges?.length"
          >No roles</span
        >
      </mat-chip-set>
    </div>
  </div>
</div>
